import bingAdsUniversalEventTracking from './bingAdsUniversalEventTracking/index.js'
import googleAdsConversion from './googleAdsConversion/index.js'
import googleAdsEvents from './googleAdsEvents/index.js'
import googleAdsPTAConversion from './googleAdsPTAConversion/index.js'
import googleAdsReservationConversion from './googleAdsReservationConversion/index.js'
import googleAdsTrueView from './googleAdsTrueView/index.js'
import rtbHouseRetargetingTag from './rtbHouseRetargetingTag/index.js'

// Add your pixels here in order to be tracked.
export default [
  googleAdsTrueView,
  googleAdsConversion,
  googleAdsEvents,
  googleAdsPTAConversion,
  googleAdsReservationConversion,
  rtbHouseRetargetingTag,
  bingAdsUniversalEventTracking
]
